// src/components/Footer.jsx

import React from "react";
import { Link } from "react-router-dom";
import appStore from "../assets/app-store.png";
import googlePlay from "../assets/google-play.png";
import mastercard from "../assets/mastercard.png";
import visa from "../assets/visa.png";
import ContactInfo from "../pages/home/components/ContactInfo";

const Footer = () => {
  return (
    <footer className="relative mt-32 md:mt-40">
      {/* Info Card */}
      <div className="relative -mt-32 md:-mt-40 z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <ContactInfo />
      </div>

      {/* Footer Content */}
      <div className="bg-[#6366F1] text-white pt-48 md:pt-56">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* App Store & Google Play */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-12 md:mb-16">
            <Link to="#" className="block">
              <img
                src={appStore}
                alt="App Store"
                className="h-14 sm:h-16 w-auto"
              />
            </Link>
            <Link to="#" className="block">
              <img
                src={googlePlay}
                alt="Google Play"
                className="h-14 sm:h-16 w-auto"
              />
            </Link>
          </div>

          {/* Description */}
          <p className="text-center text-sm sm:text-base mb-8 max-w-3xl mx-auto">
            Yıkafoni, hayatınızı kolaylaştıran modern bir hizmet platformudur;
            güvenli, hızlı ve kullanıcı dostu uygulamasıyla temizlik
            ihtiyaçlarınızı karşılar, zaman ve enerjinizi size bırakır.
          </p>

          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-8 text-sm sm:text-base">
            <a
              href="tel:+905393302525"
              className="flex items-center gap-2 hover:opacity-80"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-5 h-5 flex-shrink-0"
              >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              +90 539 330 25 25
            </a>
            <a
              href="mailto:info@yikafoni.com"
              className="flex items-center gap-2 hover:opacity-80"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-5 h-5 flex-shrink-0"
              >
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              info@yikafoni.com
            </a>
          </div>

          {/* Logo */}
          <div className="text-center mb-4">
            <h1 className="text-xl sm:text-2xl font-bold mb-1">yıkafoni</h1>
            <span className="text-xs sm:text-sm uppercase tracking-wider">
              TEMİZLİK BURADA
            </span>
          </div>

          {/* Copyright */}
          <p className="text-xs sm:text-sm text-center mb-8 opacity-80">
            Copyrights © 2024 Yıkafoni. Tüm hakları saklıdır.
          </p>

          {/* Bottom Section */}
          <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between pb-8">
            {/* Payment Methods */}
            <div className="flex gap-2 order-2 sm:order-1">
              <img src={mastercard} alt="Mastercard" className="h-6 sm:h-8" />
              <img src={visa} alt="Visa" className="h-6 sm:h-8" />
            </div>

            {/* Social Media */}
            <div className="flex gap-4 order-1 sm:order-2">
              <Link to="#" className="hover:opacity-80">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-6 h-6"
                >
                  <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z" />
                </svg>
              </Link>
              <Link to="#" className="hover:opacity-80">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-6 h-6"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </Link>
              <Link to="#" className="hover:opacity-80">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-6 h-6"
                >
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
